import Questionario from "../../components/questionario/Questionario.class";
import { cloneDeep } from "lodash";
import { httpPost } from "../../api/http_caller";
import {getRisposte} from "./checklist.repository";

export function useChecklistInit(checklistStore, praticaStore) {
  /**
   * Popola la checklist con le risposte recuperate
   * Se isFilterByToDo è true mostra solo le domande con attività da fare
   * @param questionarioOBJ
   * @param questionarioElements
   * @param statoDelQuestionario
   * @param isFilterByToDo
   * @return {Promise<void>}
   */
  const fillAndFilterChecklist = async (questionarioOBJ, questionarioElements, statoDelQuestionario, isFilterByToDo) => {
    let risposteQuestionario = await getRisposte({post: httpPost}, questionarioOBJ, statoDelQuestionario === 'readonly', praticaStore.praticaID)

    if (risposteQuestionario) {
      _fillChecklist(risposteQuestionario, questionarioElements);

      let elementiDelQuestionario = cloneDeep(checklistStore.risposteDelQuestionario);
      elementiDelQuestionario = _checkIsDeletable(elementiDelQuestionario)

      checklistStore.risposteDelQuestionario = isFilterByToDo ? _showQuestionToDo(elementiDelQuestionario) : elementiDelQuestionario

      checklistStore.onControlloDisabilitaPerCtaCompletaValidazione();
    }
  }

  /**
   * Filtra le richieste di documenti e i documenti al loro interno, tenendo solo quelle che hanno attività da fare
   * Casistiche in cui non mostrare la richiesta:
   * - documenti tutti approvati
   * - documento rifiutato, ma cittadino ha caricato e rinviato (notaio non ha ancora validato)
   * @param elementiDelQuestionario
   * @return {*[]}
   * @private
   */
  function _showQuestionToDo(elementiDelQuestionario) {
    let elements = [];
    (elementiDelQuestionario).forEach((element) => {
      let elementCloned = element;
      let cancella_riga = true;
      let almeno_un_documento_non_validato_ma_inviato = false;

      if(elementCloned.value && elementCloned.value.length > 0) {
        (elementCloned.value).forEach((documento) => {
          if(documento.is_accettato !== 1) cancella_riga = false;
          if(!documento.is_accettato && documento.bozza === 0) almeno_un_documento_non_validato_ma_inviato = true;
          if(almeno_un_documento_non_validato_ma_inviato && documento.is_accettato === 0) almeno_un_documento_non_validato_ma_inviato = false
        });
      } else {
        cancella_riga = false
      }

      if((!cancella_riga && !almeno_un_documento_non_validato_ma_inviato)) elements.push(elementCloned)
    });

    return elements;
  }

  /**
   * Setta la proprietà is_deletable per le richieste di documenti che il notaio potrebbe cancellare
   * @param elementiDelQuestionario
   * @return {*}
   * @private
   */
  function _checkIsDeletable(elementiDelQuestionario) {
    (elementiDelQuestionario).forEach((element) => {
      element.is_deletable = true;
      if(element.value) {
        element.value.forEach((item) => {
          if(item.is_accettato === 1 && item.is_blocked) element.is_deletable = false;
        })
      }
    });

    return elementiDelQuestionario;
  }

  /**
   * Inserisce le risposte della checklist per ogni richiesta di documenti
   * @param answers
   * @param checklistElements
   * @private
   */
  const _fillChecklist = (answers, checklistElements) => checklistStore.risposteDelQuestionario = Questionario._fillQuestionario(answers, checklistElements);

  return {
    fillAndFilterChecklist
  }
}